import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalizePipe } from '../../../pipes/text-pipes';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, CapitalizePipe],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss',
})
export class LanguageSwitcherComponent implements OnInit {
  private translate = inject(TranslateService);
  private userService = inject(UserService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  // Define os idiomas suportados pelo sistema
  languages = [
    { code: 'pt-BR', label: 'portugueseBrazil', flag: './assets/img/flag-br.jpg', id: 2 },
    { code: 'en-US', label: 'english', flag: './assets/img/flag-us.jpg', id: 1 },
    { code: 'es-ES', label: 'spanish', flag: './assets/img/flag-es.jpg', id: 3 },
  ];

  selectedLang = 'en-US'; // Idioma padrão

  ngOnInit() {
    // Tenta recuperar o idioma salvo anteriormente no localStorage;
    // se não existir, tenta detectar o idioma do navegador;
    // caso nenhuma opção seja válida, define 'en-US' como padrão.
    const savedLang = localStorage.getItem('lang') || this.translate.getBrowserLang() || 'en-US';

    // Verifica se o idioma recuperado está entre os idiomas suportados;
    // se não estiver, usa 'en-US' como fallback seguro.
    this.selectedLang = this.languages.some((lang) => lang.code === savedLang) ? savedLang : 'en-US';

    // Aplica o idioma selecionado ao serviço de tradução.
    this.translate.use(this.selectedLang);

    // Salva o idioma selecionado no localStorage para manter a escolha nas próximas visitas.
    localStorage.setItem('lang', this.selectedLang);
  }

  // Atualiza idioma selecionado e salva no localStorage
  selectLanguage(langCode: string) {
    this.selectedLang = langCode;
    this.translate.use(langCode);
    localStorage.setItem('lang', langCode);

    const selected = this.languages.find((lang) => lang.code === langCode);
    if (selected) {
      this.userService.updateLanguage(selected.id).subscribe({
        next: (res) => console.log('Idioma atualizado no backend:', res),
        error: (err) => console.error('Erro ao atualizar idioma no backend:', err),
      });

      // Novo: Atualiza a URL se estiver em /assessment/results
      const currentUrl = this.router.url;

      if (currentUrl.startsWith('/assessment/results') || currentUrl.startsWith('/assessment/welcome') || currentUrl.startsWith('/assessment/welcome')) {
        const queryParams = { ...this.route.snapshot.queryParams, language_id: selected.id };
        this.router
          .navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge',
          })
          .then(() => {
            location.reload();
          });
      }
    }
  }

  // Retorna o caminho da bandeira para exibição
  getFlag(langCode: string): string {
    return this.languages.find((lang) => lang.code === langCode)?.flag || '';
  }
}
